exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/restaurantorderbooking/restaurantorderbooking.component.css
// module id = ../../../../../src/app/restaurantorderbooking/restaurantorderbooking.component.css
// module chunks = main